module.exports = __webpack_public_path__ + "img/sixpackcarrier42.7f56e4a2.jpg";